import { Component, ElementRef, HostListener, ViewChild } from "@angular/core";
import { PreviewItemComponent } from "./preview-item.component";
import { NgClass } from "@angular/common";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { Subscription } from "rxjs";
import { PreviewItemContextMenuEvent } from "@ponder-core/events/ui.events";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { PreviewItemContextMenuProxy } from "./contextMenu/preview-item-context-menu-proxy.component";
import { PreviewItemContextMenuNormal } from "./contextMenu/preview-item-context-menu-normal.component";
import { PreviewItemContextMenuSpecial } from "./contextMenu/preview-item-context-menu-special.component";
import { AddCardToDeckModalComponent } from "@ponder-features/user/decks/add-card-to-deck-modal.component";
import { PreviewItemContextMenuAddToDeck } from "./contextMenu/preview-item-context-menu-add-to-deck.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { PreviewItemContextMenuOpenTabComponent } from "./contextMenu/preview-item-context-menu-open-tab.component";
import { PreviewItemContextMenuSetAvatar } from "./contextMenu/preview-item-context-menu-set-avatar.component";

@Component({
    selector: "preview-item-context-menu",
    imports: [
        NgClass,
        PreviewItemContextMenuNormal,
        PreviewItemContextMenuSpecial,
        PreviewItemContextMenuProxy,
        PreviewItemContextMenuOpenTabComponent,
        PreviewItemContextMenuAddToDeck,
        PreviewItemContextMenuSetAvatar,
        AddCardToDeckModalComponent
    ],
    templateUrl: "./preview-item-context-menu.component.html"
})
export class PreviewItemContextMenuComponet {
    @ViewChild("contextContainer") containerRef!: ElementRef<HTMLDivElement>;

    public isVisible: boolean = false;

    public previewItem?: PreviewItemComponent;
    private eventSub!: Subscription;

    public proxyIconSvg!: string;
    public deckIconSvg!: string;

    private readonly menuWidth: number = 256;

    public constructor(private element: ElementRef, private events: EventBroker) {
        this.proxyIconSvg = SvgIconMap.get(SvgIcon.Proxy)!;
        this.deckIconSvg = SvgIconMap.get(SvgIcon.Decks)!;

        this.eventSub = this.events.ui.togglePreviewItemContextMenuEvent.subscribe({
            next: (event: PreviewItemContextMenuEvent) => {
                this.previewItem = event.itemComponent;

                if (!event.itemComponent) {
                    this.isVisible = false;
                } else {
                    this.isVisible = true;

                    var bounds = this.containerRef.nativeElement.getBoundingClientRect();

                    var xOffset = event.clickX + this.getXOffsetPadding(event.clickX, bounds.width);
                    var yOffset = event.clickY + this.getYOffsetPadding(event.clickY, bounds.height);

                    this.containerRef.nativeElement.style.setProperty("left", `${xOffset}px`);
                    this.containerRef.nativeElement.style.setProperty("top", `${yOffset}px`);
                }
            }
        });
    }

    public ngOnDestroy(): void {
        this.eventSub.unsubscribe();
    }

    // -------------------------------------------------------------------------------------
    // Global Events
    // -------------------------------------------------------------------------------------

    private mouseDownOutside: boolean = false;

    @HostListener("document:keydown.escape", ["$event"]) 
    private onEscapePressed(event: KeyboardEvent): void {
        this.onClose();
    }

    @HostListener("document:mousedown", ["$event"])
    private onGlobalMouseDown(event: MouseEvent): void {
        if (!this.element.nativeElement.contains(event.target as HTMLInputElement)) {
            this.mouseDownOutside = true;
        }
    }

    @HostListener("document:mouseup", ["$event"])
    private onGlobalMouseUp(event: MouseEvent): void {
        // Did the user click outside of our modal panel?
        if (this.mouseDownOutside && !this.element.nativeElement.contains((event.target as HTMLInputElement))) {
            this.onClose();
        }

        this.mouseDownOutside = false;
    }

    @HostListener("window:scroll", ["$event"])
    private onWindowScroll(event: any): void {
        this.onClose();
    }

    // -------------------------------------------------------------------------------------
    // Actions
    // -------------------------------------------------------------------------------------

    public onClose(): void {
        this.isVisible = false;
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }

    private getXOffsetPadding(x: number, w: number): number {
        var xToEdge = window.innerWidth - x;

        if (xToEdge < w) {
            return -w;
        }

        return 0;
    }

    private getYOffsetPadding(y: number, h: number): number {
        var yToEdge = window.innerHeight - y;

        if (yToEdge < h) {
            return -h;
        }

        return 0;
    }
}